<template>
  <div>
    <el-form
      :model="addForm"
      label-width="120px"
      :rules="addFormRules"
      ref="addRuleForm"
      auto-complete="off"
      style="overflow-x: hidden; overflow-y: hidden; margin-right: 4%"
      :disabled="loadCarInfodisabled"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="装车参考单号">
            <el-input
              v-model="addForm.ReferenceNo"
              auto-complete="off"
              placeholder="请输入装车参考单号"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- :disabled="editdisbled" -->
        <el-col :span="12">
          <el-form-item label="运输方式" prop="TransportType">
            <el-select
              v-model="addForm.TransportType"
              style="width: 100%"
              placeholder="运输方式"
              @change="GetContainerNumber"
            >
              <el-option
                v-for="item in transportList"
                :label="item.transportTypeText"
                :value="item.transportTypeText"
                :key="item.transportTypeId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户" prop="OrgId">
            <el-select
              v-model="addForm.OrgId"
              style="width: 100%"
              placeholder="请选择客户"
              @change="GetOrg"
            >
              <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>

            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计装车" prop="ExpectedLoadTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="addForm.ExpectedLoadTime"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="NumberVisible">
        <el-col :span="12">
          <el-form-item label="柜号">
            <el-input
              v-model="addForm.ContainerNumber"
              auto-complete="off"
              placeholder="请输入柜号"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="封条号">
            <el-input
              v-model="addForm.SealNumber"
              auto-complete="off"
              placeholder="请输入柜号"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="NumberVisible">
        <el-col :span="12">
          <el-form-item label="SO">
            <el-input
              v-model="addForm.SONumber"
              auto-complete="off"
              placeholder="请输入SO"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="柜型">
            <el-select
              v-model="addForm.CabinetType"
              style="width: 100%"
              placeholder="请选择柜型"
            >
              <el-option
                v-for="item in CabinetTypeList"
                :label="item.cabinetTypeName"
                :value="item.cabinetTypeName"
                :key="item.cabinetTypeId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="车牌">
            <el-input
              v-model="addForm.CarNumber"
              auto-complete="off"
              placeholder="请输入车牌"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="司机">
            <el-input
              v-model="addForm.Driver"
              auto-complete="off"
              placeholder="请输入司机"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="电话">
            <el-input
              v-model="addForm.DriverPhone"
              auto-complete="off"
              placeholder="请输入电话"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
    <el-form-item label="">
    <el-tabs class="warehouseTabs" v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="中转" name="transit"></el-tab-pane>
      <el-tab-pane label="集货" name="collect"></el-tab-pane>
    </el-tabs >
    </el-form-item>
     </el-row>
      <el-row v-show="transitVisible">
        <el-form-item label="">
          <el-button type="primary" plain @click="getBoxMarkDetailed"
            >选择装车单明细</el-button
          >
        </el-form-item>
      </el-row>
      <el-row v-show="transitVisible">
        <el-form-item label="">
          <div class="otherTable">
            <el-table-bar :fixed="true" :bottom="35">
              <el-table border :data="tableData" style="width: 100%">
                <el-table-column
                  prop="containerNo"
                  label="货柜号"
                  min-width="90"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  label="运输方式"
                  min-width="90"
                  prop="transportType"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="shippingNo"
                  label="出库计划"
                  min-width="100"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  label="SKU/调入仓SKU"
                  min-width="140"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      >{{ scope.row.sku }}/{{ scope.row.inStockSKUCode }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="productNameCN"
                  label="SKU名称"
                  min-width="140"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  label="品牌/型号"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.brand }}/{{ scope.row.model }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="boxMark" label="FBA信息" min-width="180">
                  <template slot-scope="scope">
                    <span>FNSKU:{{ scope.row.fnsku }}</span
                    ><br />
                    <span>SHIPMENTID:{{ scope.row.shipmentID }}</span
                    ><br />
                    <span>箱唛条码:{{ scope.row.barCodeName }}</span
                    ><br />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="boxMark"
                  label="件数/箱号"
                  min-width="90"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.selCount }}</span
                    ><br />

                    <span>箱号:{{ scope.row.boxNo }}</span
                    ><br />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="qty"
                  label="装箱数量"
                  min-width="90"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  label="是否异常"
                  min-width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.isAbnormal == true"
                      style="color: red"
                    >
                      {{ scope.row.isAbnormalText }}
                    </span>
                    <span v-else> {{ scope.row.isAbnormalText }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="操作"
                  min-width="100"
                  align="center"
                  fixed="right"
                  v-if="loadCarInfoType == 1"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click="selBoxMark(scope.row)"
                      type="text"
                      size="small"
                      >选择指定箱</el-button
                    >
                    <br />
                    <el-button
                      @click="delboxMark(scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-table-bar>
            <div class="block">
              <el-pagination layout="total" :total="total" style="float: right">
              </el-pagination>
            </div>
          </div>
        </el-form-item>
      </el-row>

      <el-row v-show="collectVisible">
        <el-form-item label="">
          <el-button type="primary" plain @click="getTFDeliveryBox"
            >选择出库单</el-button
          >
        </el-form-item>
      </el-row>
      <el-row v-show="collectVisible">
        <el-form-item label="">
          <div class="otherTable">
            <el-table-bar :fixed="true" :bottom="35">
              <el-table border :data="tableCollectData" style="width: 100%">
                 <el-table-column
          prop="outboundNo"
          label="出库单号"
          align="center"
          sortable
        >
        </el-table-column>
                <el-table-column
          prop="orgOutboundNo"
          label="参考单号"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="containerNo"
          label="柜号"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column prop="boxQty" label="箱数" sortable align="center">
        </el-table-column>
        <el-table-column
          prop="volume"
          label="体积"
          sortable
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="weight"
          label="重量"
          sortable
          align="center"
        >
        </el-table-column>
                
                <el-table-column
                  label="操作"
                  min-width="100"
                  align="center"
                  fixed="right"
                  v-if="loadCarInfoType == 1"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click="delDeliverybox(scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-table-bar>
            <div class="block">
              <el-pagination layout="total" :total="total" style="float: right">
              </el-pagination>
            </div>
          </div>
        </el-form-item>
      </el-row>


      <el-row
        type="flex"
        class="row-bg"
        justify="center"
        v-if="loadCarInfoType == 1"
      >
        <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
          >提交</el-button
        >
      </el-row>
    </el-form>

    <!-- 装车明细数据 -->
    <el-dialog
      :visible.sync="shippingVisible"
      v-model="boxMarkVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="装车信息"
      width="90%"
      top="50px"
      style="text-align: center"
    >
    
      <div style="width: 100%; text-align: left; margin-bottom: 10px">
        <el-button type="primary" @click="onAddShippingPlan" style=""
          >确认</el-button>
      </div>
      <div v-loading="shippingLoading" element-loading-text="加载中..." style="height: 400px;">
        <el-table
          :data="shippingdata"
          highlight-current-row
          border
          style="width: 100%"
          height="400"
          @row-click="handleCellClick"
          @selection-change="selsChange"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="containerNo"
            label="货柜号"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="transportType"
            label="运输方式"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="shippingNo"
            label="出库计划"
            align="center"
            sortable
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="skuCode"
            label="SKU"
            sortable
            align="center"
            min-width="120"
          >
          </el-table-column>

          <el-table-column
            prop="productNameCN"
            label="SKU名称"
            sortable
            align="center"
            min-width="150"
          >
          </el-table-column>
          <el-table-column prop="boxQty" label="箱数" sortable align="center">
          </el-table-column>
          <el-table-column
            prop="carrierName"
            label="承运商"
            sortable
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 指定箱数据 -->
    <el-dialog
      :visible.sync="boxMarkVisible"
      v-model="boxMarkVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="箱明细"
      width="90%"
      top="50px"
      style="text-align: center"
    >
      <div style="width: 100%; text-align: left; margin-bottom: 10px">
        <el-row>
          <el-col :sm="4" :md="8" :lg="12" :xl="17">
            <el-button type="primary" @click="onAddBoxMark">
              <span> 确认</span>
            </el-button>
          </el-col>
          <el-col :sm="20" :md="16" :lg="12" :xl="7" style="text-align: right">
          
              <el-input
                v-model="choiceForm.start"
                auto-complete="off"
                placeholder="起始箱号"
                min="1"
                type="number"
                style="width:150px"
              ></el-input>
              至
              <el-input
                v-model="choiceForm.end"
                auto-complete="off"
                placeholder="结束箱号"
                min="1"
                type="number"
                style="width:150px"
              ></el-input>
         
          
              <el-tooltip class="item" effect="dark" content="装车无须扫描" placement="top" style=" margin-left: 10px;">
               <el-button type="info" @click="onAddNoNeed" >
                <span> 批量不发</span>
               </el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" content="装车扫描未发" placement="top">
                <el-button
                type="danger"
                @click="onAddNotIssued"
                title="装车扫描未发"
                >
                <span> 批量拦截</span>
               </el-button>
              </el-tooltip>
          
          </el-col>
        </el-row>
      </div>
      <el-table
        :data="boxMarkdata"
        highlight-current-row
        border
        style="width: 100%"
        ref="multipleboxMarkTable"
        height="400"
        @selection-change="boxNoselsChange"
      >
        <el-table-column type="selection" width="55" fixed="left">
        </el-table-column>

        <el-table-column
          prop="wmsBoxNo"
          label="WMS箱唛"
          align="center"
          min-width="110"
          fixed="left"
        >
        </el-table-column>
        <el-table-column
          prop="boxNo"
          label="箱号"
          align="center"
          min-width="80"
          fixed="left"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.boxNo > 0">
              {{ scope.row.boxNo }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="shippingNo"
          label="出库计划"
          align="center"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          prop="skuCode"
          label="SKU"
          align="center"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="productNameCN"
          label="SKU名称"
          align="center"
          min-width="200"
        >
        </el-table-column>
        <el-table-column label="长宽高（cm）" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.boxLength }}*{{ scope.row.boxWidth }}*{{
              scope.row.boxHeight
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="boxWeight"
          label="重量（kg）"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="qty"
          label="装箱PCS数"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="boxTypeText"
          label="箱类型"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="carrierName"
          label="承运商"
          align="center"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          label="操作"
          align="center"
          min-width="160"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              v-model="scope.row.statusBool"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="发货"
              inactive-text="拦截"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>


    <el-dialog
      :visible.sync="collectSelectVisible"
      v-model="boxMarkVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="出库单"
      width="90%"
      top="50px"
      style="text-align: center"
    >
       
      <div style="width: 100%; text-align: left; margin-bottom: 10px">
        <el-row>
          <el-col :sm="4" :md="8" :lg="12" :xl="17">
            <el-button type="primary" @click="onAddOutbound">
              <span> 确认</span>
            </el-button>
          </el-col>
          <el-col :sm="20" :md="16" :lg="12" :xl="7" style="text-align: right">
          
              <el-input
          v-model="search"
          size="mini"
          placeholder="输入参考单号搜索"/>
          
          </el-col>
        </el-row>
      </div>
      <div v-loading="collectLoading" element-loading-text="加载中..." style="height: 400px;">
        <el-table
          :data="collectdata"
          highlight-current-row
          border
          style="width: 100%"
          height="400"
          @row-click="handleCollectCellClick"
          @selection-change="selsChange"
          ref="multipleCollectTable"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="outboundNo"
            label="出库单号"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="orgOutboundNo"
            label="参考单号"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="containerNo"
            label="柜号"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column prop="boxQty" label="箱数" sortable align="center">
          </el-table-column>
          <el-table-column
            prop="volume"
            label="体积"
            sortable
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="weight"
            label="重量"
            sortable
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>


  </div>
</template>
<style>
.el-input.is-disabled .el-input__inner {
  background-color: rgb(255, 251, 251) !important;
  color: rgb(12, 12, 12) !important;
 
}
</style>
<script>
import { getReadyforTaskBasis } from "@/api/outbound/readyforTask.js";
import {
  getStockingPlanRelationByOrgID,
  getStockingBoxSumByStockingTaskID,
  GetStockingBoxListByStockingTaskID,
  addLoadCarInfo,
  getLoadCarInfoByLoadCarInfoID,
  getSholeStockingBoxSum,
  getTFDeliveryOrderByOrgID,
} from "@/api/outbound/loadingOrder.js";
export default {
  data() {
    return {
      addForm: {
        LoadCarInfoID: 0,
        OrgId: "",
        TransportType: "",
        ReferenceNo: "",
        ExpectedLoadTime: "",
        ContainerNumber: "",
        SealNumber: "",
        SONumber: "",
        CabinetType: "",
        CarNumber: "",
        Driver: "",
        DriverPhone: "",
      },
      addFormRules: {
        OrgId: [
          { required: true, message: "请选择客户", trigger: "change" },
        ],
        TransportType: [
          { required: true, message: "请选择运输方式", trigger: "change" },
        ],
        ReferenceNo: [
          { required: true, message: "请输入装车参考单号", trigger: "blur" },
          {
            message: "输入数字、字母",
            trigger: "blur",
            pattern: /^[0-9a-zA-Z\-]*$/,
          },
        ],
        ExpectedLoadTime: [
          { required: true, message: "请选择期望出货日期", trigger: "change" },
        ],
      },
      choiceForm: {
        start: "",
        end: "",
      },
      organizationList: [], //客户
      search:'',
      transportList: [], //运输方式
      addLoading: false,
      tableData: [],
      tableCollectData: [],
      total: 0,
      boxMarkdata: [],
      boxMarkVisible: false,
      CabinetTypeList: [],
      shippingSels: [],
      collectSels: [],
      NumberVisible: false,
      shippingdata: [],
      collectdata:[],
      allCollectdata:[],
      collectLoading: false,
      shippingLoading: false,
      shippingVisible: false,
      collectVisible:false,
      collectSelectVisible:false,
      transitVisible:true,
      boxNoList: [],
      boxNoSels: [],
      editdisbled: false,
      loadCarInfoType: 1,
      loadCarInfodisabled: false,
      activeName: 'transit',
    };
  },
  methods: {
    //单选选中复选框
    handleCellClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    handleCollectCellClick(row, column, event) {
      this.$refs.multipleCollectTable.toggleRowSelection(row);
    },
    //多选
    selsChange(sels) {
      this.shippingSels = sels;
      this.collectSels=sels;
    },
    // //单选选中复选框
    // boxNohandleCellClick(row) {
    //   console.log(row);
    //   this.$refs.multipleboxMarkTable.toggleRowSelection(row);
    // },

    //多选
    boxNoselsChange(sels) {
      this.boxNoSels = sels;
    },
    //批量不发
    onAddNoNeed() {
      let start = this.choiceForm.start;
      let end = this.choiceForm.end;
      let regcarNumber =/^[1-9]\d*$/;
      if (start === "") {
        this.$message({
          message: "起始箱号不能为空！",
          type: "error",
        });
        return;
      }
      if (end === "") {
        this.$message({
          message: "结束箱号不能为空！",
          type: "error",
        });
        return;
      }
      if (!regcarNumber.test(start)||!regcarNumber.test(end)) {
              this.$message({
              message: "箱号只能输入正整数！",
              type: "error",
              });
              return;
        }
      if (parseInt(start) > parseInt(end)) {
        this.$message({
          message: "起始箱号不能大于结束箱号！",
          type: "error",
        });
        return;
      }
      let that = this;
      this.$nextTick(function () {
        for (let i = parseInt(start); i <= parseInt(end); i++) {
          for (let j = 0; j < this.boxMarkdata.length; j++) {
            if (
              this.boxMarkdata[j].boxNo != "" &&
              i === parseInt(this.boxMarkdata[j].boxNo)
            ) {
              console.log(this.boxMarkdata[j]);
              that.$refs.multipleboxMarkTable.toggleRowSelection(
                this.boxMarkdata[j],
                false
              );
              break;
            }
          }
        }
      });
       this.choiceForm.start="";
       this.choiceForm.end="";
    },
    //批量拦截
    onAddNotIssued() {
       let start = this.choiceForm.start;
      let end = this.choiceForm.end;
      let regcarNumber =/^[1-9]\d*$/;
      if (start === "") {
        this.$message({
          message: "起始箱号不能为空！",
          type: "error",
        });
        return;
      }
      if (end === "") {
        this.$message({
          message: "结束箱号不能为空！",
          type: "error",
        });
        return;
      }
      if (!regcarNumber.test(start)||!regcarNumber.test(end)) {
              this.$message({
              message: "箱号只能输入正整数！",
              type: "error",
              });
              return;
        }
      if (parseInt(start) > parseInt(end)) {
        this.$message({
          message: "起始箱号不能大于结束箱号！",
          type: "error",
        });
        return;
      }

      let that = this;
      this.$nextTick(function () {
        for (let i = parseInt(start); i <= parseInt(end); i++) {
          for (let j = 0; j < this.boxMarkdata.length; j++) {
            if (
              this.boxMarkdata[j].boxNo != "" &&
              i === parseInt(this.boxMarkdata[j].boxNo)
            ) {
              console.log(this.boxMarkdata[j]);
              this.boxMarkdata[j].statusBool = false;
              that.$refs.multipleboxMarkTable.toggleRowSelection(
                this.boxMarkdata[j],
                true
              );
              break;
            }
          }
        }
      });
      this.choiceForm.start="";
      this.choiceForm.end="";
    },
    //选择运输方式
    GetContainerNumber() {
      this.tableData = [];
      this.tableCollectData=[];
      this.boxNoList = [];
      this.total = this.tableData.length;
      if (this.addForm.TransportType == "海运") {
        this.NumberVisible = true;
      } else {
        this.NumberVisible = false;
      }
    },

handleClick() {
      if (this.activeName == 'transit') {
        this.transitVisible=true;
        this.collectVisible=false;
      } else {
        this.transitVisible=false;
        this.collectVisible=true;
      }
      console.log(this.transitVisible);
    },

    //选择仓库
    GetOrg() {
      this.tableData = [];
      this.tableCollectData=[];
      this.boxNoList = [];
      this.total = this.tableData.length;
    },
    //弹出待装车明细框
    getBoxMarkDetailed() {
      let that = this;
      var transportType = this.addForm.TransportType;
      var orgId = this.addForm.OrgId;
      if (transportType == "" || transportType == null) {
        this.$message({
          message: "请选择运输方式",
          type: "error",
        });
        return;
      }
      if (orgId == "" || orgId == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }

      let pata = {
        orgId: orgId,
        transportType: transportType,
        loadCarInfoID: this.addForm.LoadCarInfoID,
      };
      this.shippingdata = [];
      this.shippingLoading = true;
      this.shippingVisible = true;
      getStockingPlanRelationByOrgID(pata).then((res) => {
        this.shippingLoading = false;
        if (res.data.success) {
          this.shippingdata = res.data.response;

          this.$nextTick(function () {
            for (let i = 0; i < this.shippingdata.length; i++) {
              for (let j = 0; j < this.tableData.length; j++) {
                if (
                  this.shippingdata[i].shippingPlanDetailID ===
                  this.tableData[j].shippingPlanDetailID
                ) {
                  that.$refs.multipleTable.toggleRowSelection(
                    this.shippingdata[i],
                    true
                  );
                  break;
                }
              }
            }
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      }).catch(() => {
        this.shippingLoading = false;
        this.$message({
          message: "请求失败",
          type: "error",
        });
      });
    },

    getTFDeliveryBox() {
      let that = this;
      var transportType = this.addForm.TransportType;
      var orgId = this.addForm.OrgId;
      if (orgId == "" || orgId == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }
       if (transportType == "" || transportType == null) {
        this.$message({
          message: "请选择运输方式",
          type: "error",
        });
        return;
      }

      let pata = {
        orgId: orgId,
        transportType: transportType,
        loadCarInfoID: this.addForm.LoadCarInfoID,
      };
      this.collectdata = [];
      this.allCollectdata=[];
      this.collectLoading = true;
      this.collectSelectVisible = true;
      getTFDeliveryOrderByOrgID(pata).then((res) => {
        this.collectLoading = false;
        if (res.data.success) {
          this.collectdata = res.data.response;
          this.allCollectdata = res.data.response;
          this.$nextTick(function () {
            for (let i = 0; i < this.collectdata.length; i++) {
              for (let j = 0; j < this.tableCollectData.length; j++) {
                if (
                  this.collectdata[i].tfOutboundID ===
                  this.tableCollectData[j].tfOutboundID
                ) {
                  that.$refs.multipleCollectTable.toggleRowSelection(
                    this.collectdata[i],
                    true
                  );
                  break;
                }
              }
            }
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      }).catch(() => {
        this.collectLoading = false;
        this.$message({
          message: "请求失败",
          type: "error",
        });
      });
    },

    delDeliverybox(row) {
       this.$confirm("确认删除：" + row.orgOutboundNo + "吗?", "提示", {}).then(() => {
        const index = this.tableCollectData.findIndex(
          (item) =>
            item.tfOutboundID === row.tfOutboundID
        );
        if (index > -1) {
          this.tableCollectData.splice(index, 1);
          this.$message({
            message: "删除成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "删除失败",
            type: "error",
          });
        }
      });
    },

    //选择计划
    onAddShippingPlan() {
      var shippingData = this.shippingSels;
      if (shippingData == null || shippingData.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }
      var arr = [];
      //已添加的计划
      let tableIds = this.tableData.map((item) => item.shippingPlanDetailID);
      //选择的计划
      let shippingIds = shippingData.map((item) => item.shippingPlanDetailID);
      //数据对比
      //已添加不存在选择的计划中（即删除）
      for (var i = 0; i < this.tableData.length; i++) {
        if (!shippingIds.includes(this.tableData[i].shippingPlanDetailID)) {
          //删除计划
          const indexDel = this.tableData.findIndex(
            (itemship) =>
              itemship.shippingPlanDetailID ===
              this.tableData[i].shippingPlanDetailID
          );
          //删除箱明细
          for (var j = 0; j < this.boxNoList.length; j++) {
            const delindex = this.boxNoList.findIndex(
              (item) =>
                item.shippingPlanDetailID ===
                this.tableData[i].shippingPlanDetailID
            );
            if (delindex > -1) {
              this.boxNoList.splice(delindex, 1);
              j--;
            } else break;
          }
          this.tableData.splice(indexDel, 1);
          i--;
        }
      }
      //选择的计划不存在已添加中（即新增）
      shippingData.forEach((item, index) => {
        if (!tableIds.includes(item.shippingPlanDetailID)) {
          arr.push(item);
        }
      });
      this.shippingVisible = false;
      console.log("add",arr);
      if (arr.length > 0) {
        let pata = {
          stockingTaskID: arr.map((item) => item.stockingTaskID).join(","),
          shippingPlanDetailID: arr
            .map((item) => item.shippingPlanDetailID)
            .join(","),
          boxList: 0,
          stockingBoxSumID: 0,
          loadCarInfoID: this.addForm.LoadCarInfoID,
        };
        console.log(pata);

        getStockingBoxSumByStockingTaskID(pata).then((res) => {
          if (res.data.success) {
            res.data.response.loadingList.forEach((item, index) => {
              this.tableData.push(item);
            });
             res.data.response.outboundList.forEach((item, index) => {
              this.tableCollectData.push(item);
            });
            res.data.response.boxList.forEach((item, index) => {
              this.boxNoList.push(item);
            });
            this.total = this.tableData.length;
            console.log("计划明细", this.tableData);
            console.log("箱明细", this.boxNoList);
            console.log("出库明细", this.outboundList);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
    },


    //选择发货单
    onAddOutbound() {
      var collectData = this.collectSels;
      if (collectData == null || collectData.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }
      this.tableCollectData=collectData;
      this.collectSelectVisible = false;
      console.log(collectData);

    },

    //删除计划箱汇总
    delboxMark(row) {
      this.$confirm("确认删除SKU：" + row.sku + "吗?", "提示", {}).then(() => {
        const index = this.tableData.findIndex(
          (item) =>
            item.stockingBoxSumID === row.stockingBoxSumID &&
            item.shippingPlanDetailID === row.shippingPlanDetailID
        );
        if (index > -1) {
          this.tableData.splice(index, 1);

          this.total = this.tableData.length;
          //删除箱明细
          for (var i = 0; i < this.boxNoList.length; i++) {
            const delindex = this.boxNoList.findIndex(
              (item) =>
                item.stockingBoxSumID === row.stockingBoxSumID &&
                item.shippingPlanDetailID === row.shippingPlanDetailID
            );
            if (delindex > -1) {
              this.boxNoList.splice(delindex, 1);
              i--;
            } else break;
          }
          this.$message({
            message: "删除成功",
            type: "success",
          });

          console.log("删除计划明细", this.tableData);
          console.log("删除箱明细", this.boxNoList);
        } else {
          this.$message({
            message: "删除失败",
            type: "error",
          });
        }
      });
    },
    //查询计划箱明细
    selBoxMark(row) {
      let that = this;
      let pata = {
        stockingTaskID: row.stockingTaskID,
        shippingPlanDetailID: row.shippingPlanDetailID,
        stockingBoxSumID: row.stockingBoxSumID,
        loadCarInfoID: this.addForm.LoadCarInfoID,
      };
      this.boxMarkVisible = true;
      this.boxMarkdata = [];
      GetStockingBoxListByStockingTaskID(pata).then((res) => {
        if (res.data.success) {
          this.boxMarkdata = res.data.response;
          that.$refs.multipleboxMarkTable.clearSelection();
          this.$nextTick(function () {
            for (let i = 0; i < this.boxMarkdata.length; i++) {
              for (let j = 0; j < this.boxNoList.length; j++) {
                if (
                  this.boxMarkdata[i].stockingBoxListID ===
                  this.boxNoList[j].stockingBoxListID
                ) {
                  this.boxMarkdata[i].statusBool =
                    this.boxNoList[j].boxStatus == 10 ? true : false;
                  that.$refs.multipleboxMarkTable.toggleRowSelection(
                    this.boxMarkdata[i],
                    true
                  );
                  break;
                }
              }
            }
            console.log(this.boxMarkdata);
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //选择箱明细
    onAddBoxMark() {
      var boxNoData = this.boxNoSels;
      if (boxNoData == null || boxNoData.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }

      var stockingTaskID = boxNoData[0].stockingTaskID;
      var shippingPlanDetailID = boxNoData[0].shippingPlanDetailID;
      var stockingBoxSumID = boxNoData[0].stockingBoxSumID;
      let pata = {
        stockingTaskID: stockingTaskID,
        shippingPlanDetailID: shippingPlanDetailID,
        stockingBoxSumID: stockingBoxSumID,
        boxList: boxNoData.map((item) => item.stockingBoxListID).join(","),
        loadCarInfoID: this.addForm.LoadCarInfoID,
      };
      console.log(pata);

      getStockingBoxSumByStockingTaskID(pata).then((res) => {
        if (res.data.success) {
          this.boxMarkVisible = false;
          //删除箱明细
          for (var i = 0; i < this.boxNoList.length; i++) {
            const delindextable = this.tableData.findIndex(
              (item) =>
                item.shippingPlanDetailID === shippingPlanDetailID &&
                item.stockingBoxSumID === stockingBoxSumID
            );
            if (delindextable > -1) {
              this.tableData.splice(delindextable, 1);
            }

            const delindex = this.boxNoList.findIndex(
              (item) =>
                item.shippingPlanDetailID === shippingPlanDetailID &&
                item.stockingBoxSumID === stockingBoxSumID
            );
            if (delindex > -1) {
              this.boxNoList.splice(delindex, 1);
              i--;
            } else break;
          }
          //添加装车明细
          res.data.response.loadingList.forEach((item, index) => {
            this.tableData.push(item);
          });
          res.data.response.boxList.forEach((item, index) => {
            this.boxNoList.push(item);
          });
          this.total = this.tableData.length;

          for (let i = 0; i < boxNoData.length; i++) {
            for (let j = 0; j < this.boxNoList.length; j++) {
              if (
                boxNoData[i].stockingBoxListID ===
                this.boxNoList[j].stockingBoxListID
              ) {
                this.boxNoList[j].boxStatus =
                  boxNoData[i].statusBool === true ? 10 : 20;
              }
            }
          }

          console.log("计划明细", this.tableData);
          console.log("箱明细", this.boxNoList);
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //新增
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);

      if (this.tableData.length == 0 && this.tableCollectData.length==0) {
        this.$message({
          message: "请选择装车数据",
          type: "error",
        });
        return;
      }
      
      para.BoxList = this.boxNoList;
      para.CollectData=this.tableCollectData;
      console.log(para);
      if (para.TransportType != "海运") {
        para.ContainerNumber = "";
        para.SealNumber = "";
        para.SONumber = "";
        para.CabinetType = "";
      }
      console.log(11, para);
      if (para.CarNumber!=null && para.CarNumber != "") {
        let regcarNumber =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/;
        if (!regcarNumber.test(para.CarNumber)) {
          this.$message({
            message: "请输入正确的车牌号，正确格式为（京A88888）",
            type: "error",
          });
          return false;
        }
      }
      let _this = this;
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              var user = JSON.parse(window.localStorage.user);
              if (!user && user.id == 0) {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect
                    ? _this.$route.query.redirect
                    : "/"
                );
              }

              this.addLoading = true;

              addLoadCarInfo(para).then((res) => {
                this.addLoading = false;
                console.log(res);
                if (res.data.success) {
                  this.$refs["addRuleForm"].resetFields();
                  this.tableData = [];
                  this.total = 0;
                  this.$alert(
                    "装车单号：" + res.data.msg + "，可在装车单管理页面查询",
                    "提交成功",
                    {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        window.parent.postMessage("close", "*");
                      },
                    }
                  );
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    //查询装车单详情
    onGetLoadCarInfoById(loadCarInfoID, type) {
      if (loadCarInfoID == 0 || loadCarInfoID == undefined) {
        this.$message({
          message: "备货单ID错误",
          type: "error",
        });
        return;
      }
      let pata = {
        loadCarInfoID: loadCarInfoID,
        type: type,
      };
      getLoadCarInfoByLoadCarInfoID(pata).then((res) => {
        if (res.data.success) {
          var details = res.data.response.details;
          this.addForm.LoadCarInfoID = details.loadCarInfoID;
          this.addForm.ReferenceNo = details.referenceNo;
          this.addForm.TransportType = details.transportType;
          this.addForm.OrgId = details.orgID;
          this.addForm.ExpectedLoadTime = details.expectedLoadTime;
          this.addForm.ContainerNumber = details.containerNumber;
          this.addForm.SealNumber = details.sealNumber;
          this.addForm.SONumber = details.soNumber;
          this.addForm.CabinetType = details.cabinetType;
          this.addForm.CarNumber = details.carNumber;
          this.addForm.Driver = details.driver;
          this.addForm.DriverPhone = details.driverPhone;
          this.loadCarInfoStatus = details.status;
          console.info(this.addForm);
          this.GetContainerNumber();

          res.data.response.loadingList.forEach((item, index) => {
            this.tableData.push(item);
          });
          this.total = this.tableData.length;
           res.data.response.outboundList.forEach((item, index) => {
            this.tableCollectData.push(item);
          });
          res.data.response.boxList.forEach((item, index) => {
            this.boxNoList.push(item);
          });
          console.log("计划明细1", this.tableData);
          console.log("箱明细1", this.boxNoList);
          console.log("出库明细1", this.outboundList);
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    getSholeStocking(stockingTaskID) {
      let pata = {
        stockingTaskID: stockingTaskID,
      };
      getSholeStockingBoxSum(pata).then((res) => {
        if (res.data.success) {
          let firstModel=res.data.response.loadingList[0];
          this.addForm.ReferenceNo = firstModel.jpContainerNo;
          this.addForm.DriverPhone = firstModel.driverPhone;
          this.addForm.Driver = firstModel.driver;
          this.addForm.CarNumber = firstModel.carNumber;
          this.addForm.SONumber = firstModel.soNumber;
          this.addForm.SealNumber = firstModel.sealNumber;
          this.addForm.ContainerNumber = firstModel.containerNumber;
          this.addForm.ExpectedLoadTime = firstModel.deliveryDate;
          res.data.response.loadingList.forEach((item, index) => {
            this.tableData.push(item);
          });
          res.data.response.boxList.forEach((item, index) => {
            this.boxNoList.push(item);
          });
          this.total = this.tableData.length;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
    getReadyforTaskBasis("").then((res) => {
      this.transportList = res.data.response.transportdata;
      this.CabinetTypeList = res.data.response.cabinetTypeList;
    });

    let user = JSON.parse(window.localStorage.user);
    this.organizationList= user.organizationList;

    var query = this.$route.query;
    console.log("dd", query.loadCarInfoID);
    if (query.loadCarInfoID != undefined) {
      this.loadCarInfoType = query.type;
      this.loadCarInfodisabled = query.type == 1 ? false : true;
      this.editdisbled = true;

      this.onGetLoadCarInfoById(query.loadCarInfoID, query.type);
    }
    if (query.stockingTaskIDS != undefined) {
      this.addForm.OrgId = parseInt(query.orgId);
      this.addForm.TransportType = query.transportType;
      console.log("aa", query);
      this.GetContainerNumber();
      this.$nextTick(function () {
        this.getSholeStocking(query.stockingTaskIDS);
      });
    }
  },
watch: {
    search(newValue, oldValue) {
      // 在这里执行您的操作
      console.log('输入值发生变化：', newValue);

      this.collectdata= this.allCollectdata.filter(data => !newValue ||data.orgOutboundNo.toLowerCase().includes(newValue.toLowerCase()))

      this.$nextTick(function () {
            for (let i = 0; i < this.collectdata.length; i++) {
              for (let j = 0; j < this.tableCollectData.length; j++) {
                if (
                  this.collectdata[i].tfOutboundID ===
                  this.tableCollectData[j].tfOutboundID
                ) {
                  this.$refs.multipleCollectTable.toggleRowSelection(
                    this.collectdata[i],
                    true
                  );
                  break;
                }
              }
            }
          });
    }
},
}
</script>

<style lang="less" scoped>
  .warehouseTabs {
    box-shadow: none;
    border-bottom: none;
    ::v-deep>.el-tabs__content {
        padding: 0 !important;
    }
}
</style>
